import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import {
  Search,
  ShoppingCart,
  Menu,
  X,
  Heart,
  Phone,
  MapPin
} from 'lucide-react';
import { categories } from './categoriesData';
import { products } from './productsData';

const categoriesMenu = [
  {
    title: 'الأدوية والعلاج',
    items: [
      { name: 'الأدوية', page: 'medicines' },
      { name: 'رفع روشتة', page: 'prescription' },
      { name: 'الإسعافات الأولية', page: 'first-aid' }
    ]
  },
  {
    title: 'الفيتامينات والتغذية',
    items: [
      { name: 'الفيتامينات', page: 'vitamins' },
      { name: 'المكملات الغذائية', page: 'supplements' },
      { name: 'التغذية الرياضية', page: 'sports-nutrition' },
      { name: 'إنقاص الوزن', page: 'weight-loss' },
      { name: 'الأعشاب الطبيعية', page: 'herbs' },
      { name: 'الزيوت الطبيعية', page: 'natural-oils' }
    ]
  },
  {
    title: 'الأم والطفل',
    items: [
      { name: 'منتجات الأطفال', page: 'children-products' },
      { name: 'الحمل والرضاعة', page: 'pregnancy-motherhood' }
    ]
  },
  {
    title: 'العناية الشخصية',
    items: [
      { name: 'العناية بالبشرة', page: 'skin-care' },
      { name: 'العناية بالشعر', page: 'hair-care' },
      { name: 'العناية بالفم والأسنان', page: 'oral-care' },
      { name: 'العناية بالعيون', page: 'eye-care' },
      { name: 'العناية بالقدم', page: 'foot-care' },
      { name: 'العناية الرجالية', page: 'men-care' },
      { name: 'العناية النسائية', page: 'women-care' }
    ]
  },
  {
    title: 'الأجهزة والمستلزمات الطبية',
    items: [
      { name: 'الأجهزة الطبية', page: 'medical-devices' },
      { name: 'قياس السكر', page: 'diabetes-devices' },
      { name: 'قياس الضغط', page: 'blood-pressure' },
      { name: 'المستلزمات الطبية', page: 'medical-supplies' }
    ]
  },
  {
    title: 'الحماية والرعاية',
    items: [
      { name: 'المطهرات والمعقمات', page: 'sanitizers' },
      { name: 'الكمامات والحماية', page: 'protection' },
      { name: 'كبار السن', page: 'elder-care' }
    ]
  },
  {
    title: 'العروض',
    items: [
      { name: 'العروض', page: 'offers' },
      { name: 'الباقات', page: 'offers' }
    ]
  }
];

const Header = ({ totalItems, totalFavorites, setCurrentPage }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openMobileGroups, setOpenMobileGroups] = useState({});
  const [searchQuery, setSearchQuery] = useState('');
  const [searchError, setSearchError] = useState('');

  // بيدور الأول على تطابق اسم منتج، ولو مفيش بيدور على اسم فئة، وفي الحالتين يودّي لصفحة الفئة
  const handleSearchSubmit = (e) => {
    if (e) e.preventDefault();

    const query = searchQuery.trim();
    if (!query) return;

    const normalizedQuery = query.toLowerCase();

    const productMatch = products.find((product) =>
      product.name.toLowerCase().includes(normalizedQuery)
    );

    const categoryMatch = categories.find(
      (cat) => cat.page && cat.name.toLowerCase().includes(normalizedQuery)
    );

    const targetPage = productMatch ? productMatch.categoryPage : categoryMatch ? categoryMatch.page : null;

    if (targetPage) {
      setSearchError('');
      setSearchQuery('');
      setIsMenuOpen(false);
      setCurrentPage(targetPage);
    } else {
      setSearchError('مفيش نتائج مطابقة، جرب كلمة تانية');
    }
  };

  // بيحدد يروح لصفحة تانية عادي، أو لو الوجهة "تواصل معنا"
  // يودّي للصفحة الرئيسية الأول وبعدين ينزل (scroll) لقسم التواصل بتاعها
  const handleNavigationClick = (page) => {
    setIsMenuOpen(false);

    if (page === 'contact') {
      setCurrentPage('home');
      // بنستنى لحد ما الصفحة الرئيسية والقسم يترندر في الـ DOM قبل ما نعمل scroll
      setTimeout(() => {
        const contactSection = document.getElementById('contact');
        if (contactSection) {
          contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
      return;
    }

    setCurrentPage(page);
  };

  const toggleMobileGroup = (title) => {
    setOpenMobileGroups((prev) => ({ ...prev, [title]: !prev[title] }));
  };

  return (
    <header className="sticky top-0 z-50 bg-white font-['Cairo'] shadow-sm">
      {/* شريط المعلومات العلوي */}
      <div className="bg-[#10B981] py-2 text-white">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between text-sm">
            <div className="flex items-center gap-5">
              <a href="tel:+966111234567" className="flex items-center gap-1.5 transition-opacity hover:opacity-80">
                <Phone className="h-4 w-4" />
                <span>+966 11 123 4567</span>
              </a>
              <div className="hidden items-center gap-1.5 sm:flex">
                <MapPin className="h-4 w-4" />
                <span>الرياض، المملكة العربية السعودية</span>
              </div>
            </div>
            <div className="hidden md:block">
              <span>توصيل مجاني للطلبات أكثر من 200 ريال</span>
            </div>
          </div>
        </div>
      </div>

      {/* الهيدر الرئيسي */}
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between gap-4">
          {/* الشعار */}
          <div
            className="flex cursor-pointer items-center transition-opacity hover:opacity-90"
            onClick={() => handleNavigationClick('home')}
          >
            <div className="ml-3 flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-[#10B981] text-lg font-bold text-white shadow-sm shadow-[#10B981]/30">
              ريان
            </div>
            <div>
              <h1 className="text-2xl font-bold text-[#10B981]">صيدلية الريان</h1>
              <p className="text-sm text-gray-500">صحتك أولويتنا</p>
            </div>
          </div>

          {/* شريط البحث - مخفي في الشاشات الصغيرة */}
          <form onSubmit={handleSearchSubmit} className="mx-8 hidden max-w-md flex-1 md:flex">
            <div className="relative w-full">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  if (searchError) setSearchError('');
                }}
                placeholder="ابحث عن الأدوية والمنتجات..."
                className="w-full rounded-xl border-2 border-gray-200 py-2.5 pl-4 pr-10 outline-none transition-colors duration-200 focus:border-[#10B981]"
              />
              <Search className="absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
              {searchError && (
                <p className="absolute right-0 top-full mt-1 text-xs font-medium text-red-500">{searchError}</p>
              )}
            </div>
            <button
              type="submit"
              className="mr-2 rounded-xl bg-[#10B981] px-5 py-2.5 font-semibold text-white transition-all duration-200 hover:bg-[#0ea173] active:scale-95"
            >
              بحث
            </button>
          </form>

          {/* أيقونات الحساب والسلة والمفضلة */}
          <div className="flex items-center gap-2">
            <button
              className="relative rounded-full p-2.5 text-gray-600 transition-colors duration-200 hover:bg-[#10B981]/10 hover:text-[#10B981]"
              onClick={() => handleNavigationClick('favorites')}
              aria-label="المفضلة"
            >
              <Heart className="h-5 w-5" />
              {totalFavorites > 0 && (
                <span className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-xs font-bold text-white">
                  {totalFavorites}
                </span>
              )}
            </button>

            <button
              className="relative rounded-full p-2.5 text-gray-600 transition-colors duration-200 hover:bg-[#10B981]/10 hover:text-[#10B981]"
              onClick={() => handleNavigationClick('cart')}
              aria-label="سلة التسوق"
            >
              <ShoppingCart className="h-5 w-5" />
              {totalItems > 0 && (
                <span className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-xs font-bold text-white">
                  {totalItems}
                </span>
              )}
            </button>

            {/* زر القائمة للهواتف */}
            <button
              className="rounded-full p-2.5 text-gray-600 transition-colors duration-200 hover:bg-[#10B981]/10 hover:text-[#10B981] md:hidden"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="القائمة"
            >
              {isMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </button>
          </div>
        </div>

        {/* شريط البحث للهواتف */}
        <form onSubmit={handleSearchSubmit} className="mt-4 md:hidden">
          <div className="relative">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (searchError) setSearchError('');
              }}
              placeholder="ابحث عن الأدوية والمنتجات..."
              className="w-full rounded-xl border-2 border-gray-200 py-2.5 pl-4 pr-10 outline-none transition-colors duration-200 focus:border-[#10B981]"
            />
            <Search className="absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
            {searchError && (
              <p className="mt-1 text-xs font-medium text-red-500">{searchError}</p>
            )}
          </div>
        </form>
      </div>

      {/* شريط التنقل */}
      <nav className="border-t bg-gray-50">
        <div className="container mx-auto px-4">

          {/* التنقل للشاشات الكبيرة */}
          <div className="hidden items-center justify-center py-3 md:flex">
            <ul className="flex flex-wrap items-center justify-center gap-1">

              <li>
                <button
                  type="button"
                  className="rounded-lg px-3 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-[#10B981]/10 hover:text-[#10B981]"
                  onClick={() => handleNavigationClick('home')}
                >
                  الرئيسية
                </button>
              </li>

              {/* كل مجموعة فئات كرابط مستقل بقائمة منسدلة خاصة بها */}
              {categoriesMenu.map((group) => (
                <li key={group.title} className="group relative">
                  <button
                    type="button"
                    className="flex items-center gap-1 rounded-lg px-3 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-[#10B981]/10 hover:text-[#10B981]"
                  >
                    {group.title}
                    <ChevronDown className="h-4 w-4" />
                  </button>

                  <div className="absolute right-0 top-full z-50 hidden w-64 rounded-xl border border-gray-100 bg-white p-2 shadow-xl group-hover:block">
                    {group.items.map((category) => (
                      <button
                        key={category.page}
                        type="button"
                        onClick={() => handleNavigationClick(category.page)}
                        className="block w-full rounded-lg px-4 py-3 text-right text-sm text-gray-700 transition-colors hover:bg-[#10B981]/10 hover:text-[#10B981]"
                      >
                        {category.name}
                      </button>
                    ))}
                  </div>
                </li>
              ))}

              <li>
                <button
                  type="button"
                  className="rounded-lg px-3 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-[#10B981]/10 hover:text-[#10B981]"
                  onClick={() => handleNavigationClick('contact')}
                >
                  اتصل بنا
                </button>
              </li>

            </ul>
          </div>

          {/* القائمة المنسدلة للهواتف */}
          {isMenuOpen && (
            <div className="py-4 md:hidden">
              <ul className="space-y-1">

                <li>
                  <button
                    type="button"
                    className="block w-full rounded-lg px-3 py-2.5 text-right font-medium text-gray-700 hover:bg-[#10B981]/10 hover:text-[#10B981]"
                    onClick={() => handleNavigationClick('home')}
                  >
                    الرئيسية
                  </button>
                </li>

                {/* الفئات مقسمة كأكورديون */}
                {categoriesMenu.map((group) => (
                  <li key={group.title}>
                    <button
                      type="button"
                      className="flex w-full items-center justify-between rounded-lg px-3 py-2.5 text-right font-semibold text-gray-800 hover:bg-[#10B981]/10 hover:text-[#10B981]"
                      onClick={() => toggleMobileGroup(group.title)}
                      aria-expanded={!!openMobileGroups[group.title]}
                    >
                      {group.title}
                      <ChevronDown
                        className={`h-4 w-4 transition-transform duration-200 ${
                          openMobileGroups[group.title] ? 'rotate-180' : ''
                        }`}
                      />
                    </button>

                    {openMobileGroups[group.title] && (
                      <ul className="mr-3 space-y-1 border-r-2 border-[#10B981]/20 pr-3">
                        {group.items.map((item) => (
                          <li key={item.page}>
                            <button
                              type="button"
                              className="block w-full rounded-lg px-3 py-2 text-right text-sm text-gray-600 transition-colors hover:bg-[#10B981]/10 hover:text-[#10B981]"
                              onClick={() => handleNavigationClick(item.page)}
                            >
                              {item.name}
                            </button>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}

                <li>
                  <button
                    type="button"
                    className="block w-full rounded-lg px-3 py-2.5 text-right font-medium text-gray-700 hover:bg-[#10B981]/10 hover:text-[#10B981]"
                    onClick={() => handleNavigationClick('contact')}
                  >
                    اتصل بنا
                  </button>
                </li>

              </ul>
            </div>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Header;
